import { useCallback, useRef } from 'react'
import { RecoilState, SetterOrUpdater, useRecoilState } from 'recoil'

type GetStateAction<S> = () => S
function useGetRecoilState<S>(recoilState: RecoilState<S>): [S, SetterOrUpdater<S>, GetStateAction<S>] {
  const [state, setState] = useRecoilState(recoilState)
  const stateRef = useRef(state)
  stateRef.current = state

  const getState = useCallback(() => stateRef.current, [])

  const set = (value: S | ((prev: S) => S)) => {
    setState((prev: S) => {
      const next = typeof value === 'function' ? (value as (prev: S) => S)(prev) : value
      stateRef.current = next as Awaited<S>
      return next
    })
  }

  return [state, set, getState]
}

export default useGetRecoilState
